import React, { useEffect, useState } from "react";
import { login, SetProfile, UserDetail, verifySMSCode } from "../../axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import MyAccount from "../my-account";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/configureStore";
import { signInUser } from "./accountSlice";
import persianToEnglishNumbers from "../../tools/farsiToEnglishNumber";
import { normalizePhoneNumber } from "../../tools/normalizePhoneNumber";

export const enNumberConvertor = (e: any) => {
  let regex = new RegExp(/^\d+$/);
  let str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (regex.test(str)) return true;
  e.preventDefault();
  return false;
};

const Login = () => {
  const dispatch = useAppDispatch();

  const [currentUserDetail, setCurrentUserDetail] = useState<any>("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [recivedCode, setRecivedCode] = useState("");
  const [verifyCode, setVerifyCode] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [maghta, setMaghta] = useState("");

  const phoneNumberRegex = /^09\d{0,9}$/; // Regex to validate input dynamically
  const cleanedPhone = normalizePhoneNumber(phoneNumber);
  console.log("cleanedphone", cleanedPhone);

  const submitLogin = (e: any) => {
    e.preventDefault();
    // if (!/^09\d{9}$/.test(phoneNumber)) {
    //   toast.error("شماره تلفن باید با 09 شروع شود و 11 رقم باشد");
    //   return;
    // }
    setLoading(true);
    login(cleanedPhone).then(({ data }) => {
      setRecivedCode(data.slice(11, 17));
      setLoading(false);
      setStep(2);
    });
  };

  console.log("recieved", recivedCode);

  const handelLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      setLoading(false);

      if (verifyCode === recivedCode) {
        const { data: userDetail } = await UserDetail(cleanedPhone);
        setCurrentUserDetail(userDetail[0]);
        localStorage.setItem("user", cleanedPhone);
        localStorage.setItem("phonenumber", cleanedPhone);
        localStorage.setItem("login", "true");
        localStorage.setItem("timestamp", new Date().toISOString());

        if (userDetail[0].maghta && userDetail[0].maghta.length > 0) {
          toast.success("ورود با موفقیت انجام شد");
          window.location.reload();
          setLoggedIn(true);
        } else {
          setStep(3);
        }
      } else {
        toast.error("کد ورودی اشتباه است");
      }
    } catch (error) {
      // Handle the rejected promise (error)
      toast.error("کد ورودی اشتباه است یااتصال برقرار نشد");

      setLoading(false);
    }
  };

  //keep the user detail onchanged , but push maghta property to the user detail
  const handleMaghta = async (e: any) => {
    e.preventDefault();

    if (maghta) {
      const { data } = await SetProfile(
        cleanedPhone,
        currentUserDetail?.name,
        currentUserDetail?.family,
        currentUserDetail?.email,
        maghta
      );

      if (data == "1") {
        toast.success("ورود با موفقیت انجام شد");
        window.location.reload();
        setLoggedIn(true);
      } else {
        toast.error("اطلاعات مقطع ثبت نشد لطفا بعدا امتحان کنید");
        window.location.reload();
      }
    } else {
      toast.error("انتخاب مقطع الزامی میباشد");
    }
  };

  useEffect(() => {
    let loginStorage = localStorage.getItem("phonenumber");
    if (loginStorage) {
      setLoggedIn(true);
    }
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>
                  <li>ورود و ثبت نام</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="customer_login mt-60">
        <div className="container">
          <div className="row" style={{ justifyContent: "center" }}>
            {loggedIn ? (
              <MyAccount />
            ) : (
              <div className="col-lg-6 col-md-6">
                <div className="account_form">
                  <h2>ورود و ثبت نام</h2>
                  {step === 1 ? (
                    <form onSubmit={submitLogin}>
                      <p>
                        <label>
                          شماره همراه<span>*</span>
                        </label>
                        <input
                          id="phoneNumInput"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          inputMode="numeric"
                        ></input>
                      </p>

                      <div className="login_submit">
                        <label htmlFor="remember">
                          <input id="remember" type="checkbox"></input> به خاطر
                          سپاری
                        </label>
                        <button id="submitBtn" disabled={loading} type="submit">
                          ورود
                        </button>
                      </div>
                    </form>
                  ) : step === 2 ? (
                    <form onSubmit={handelLogin}>
                      <p>
                        <label>
                          کد تایید<span>*</span>
                        </label>
                        <input
                          pattern="[0-9]*"
                          inputMode="numeric"
                          id="phoneNumInput"
                          value={verifyCode}
                          onChange={(e) => setVerifyCode(e.target.value)}
                          type="text"
                        ></input>
                      </p>

                      <p onClick={() => setStep(1)}>تغییر شماره همراه</p>

                      <div className="login_submit">
                        <button id="submitBtn" disabled={loading} type="submit">
                          تایید
                        </button>
                      </div>
                    </form>
                  ) : step === 3 ? (
                    <form
                      onSubmit={(e) => handleMaghta(e)}
                      className="d-flex flex-column gap-2"
                    >
                      <label>
                        لطفا اگر در مقطع علوم پایه هستید, گزینه مربوطه و اگر در
                        مقاطع بالاتری هستید, گزینه دیگر را انتخاب کنید
                      </label>
                      <div>
                        <div
                          onClick={() => setMaghta("علوم پایه")}
                          className="input-group"
                        >
                          <span
                            className={maghta === "علوم پایه" ? "active" : ""}
                          ></span>
                          <p className="m-0">علوم پایه</p>
                        </div>
                        <div
                          onClick={() => setMaghta("مقاطع بالاتر")}
                          className="input-group"
                        >
                          <span
                            className={
                              maghta === "مقاطع بالاتر" ? "active" : ""
                            }
                          ></span>
                          <p className="m-0">مقاطع بالاتر</p>
                        </div>
                      </div>
                      <button type="submit">ورود به سامانه</button>
                    </form>
                  ) : null}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
